<ng-container dsMetadataRepresentation></ng-container>